import { chatTagsOf } from '../config/customerTags';

// Nhãn tag KH (chỉ MH / VC / ĐT) hiện TRƯỚC tên KH trong chat (danh sách + header) để nắm nhanh thông tin KH.
// Rỗng -> null. Dùng chung cho ChatPage / CustomerChat / ChatWidget (giữ parity).
export default function ChatCustTags({ tags, size = 10 }) {
  const list = chatTagsOf(tags);
  if (!list.length) return null;
  return (
    <>
      {list.map((t) => (
        <span
          key={t.v}
          style={{
            fontSize: size, fontWeight: 700, lineHeight: 1.4, padding: '1px 5px', borderRadius: 5,
            marginRight: 3, whiteSpace: 'nowrap', verticalAlign: 'middle',
            color: t.color, background: `color-mix(in srgb, ${t.color} 16%, transparent)`,
          }}
        >
          {t.label}
        </span>
      ))}
    </>
  );
}
